import { KeycloakSessionService } from '@unitedtraders/session-service';
import type { GetLogger } from '@unitedtraders/utex-site-common';
import { VisitCollector } from '@unitedtraders/visit-collector';
import { inject, injectable } from 'inversify';
import Cookies from 'js-cookie';
import { format } from 'url';

import { EventName } from '../conts/EventName';
import { iocNames } from '../iocNames';
import type { AppConfig } from '../types/AppConfig';

@injectable()
export class SessionService extends KeycloakSessionService {
  constructor(
    @inject(iocNames.cookies) cookies: Cookies.CookiesStatic,
    @inject(iocNames.getLogger) getLogger: GetLogger,
    @inject(iocNames.appConfig) { dizraptorGateway, sessionService, siteUrl }: AppConfig,
    @inject(iocNames.visitCollector) private visitCollector: VisitCollector
  ) {
    super(
      {
        clientId: sessionService.clientId,
        realm: sessionService.realm,
        url: dizraptorGateway.rest ? format({ ...dizraptorGateway.rest.url }) : ''
      },
      cookies,
      new URL(siteUrl).hostname,
      getLogger
    );

    this.tokens.subscribe(tokens => {
      if (tokens) {
        this.visitCollector.onLogin?.(tokens.parsedAccessToken.user_id);
      } else {
        this.visitCollector.onLogout?.();
      }
    });
  }

  public logout = () => {
    super.getKeycloak().logout().catch(console.error);
    this.visitCollector.send({ hashData: { eventName: EventName.ManualLogout } });
  };
}
